import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import TestForm from "../components/TestForm";
import { changeField, initializeForm, login } from "../modules/auth";

const TestContainer = ({ history }) => {
  const dispatch = useDispatch();
  /*
   * API Test Mode 여부 판단 
   * boolean test
   */
  const [ test, setTest ] = useState(false);
  const { form, auth, authError } = useSelector(({ auth }) => ({
    form: auth.login,
    auth: auth.auth,
    authError: auth.authError,
  }));
  const onChange = (e) => {
    const { value, name } = e.target;
    dispatch(
      changeField({
        form: "login",
        key: name,
        value,
      })
    );
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const { t_type, diag_t_id, name, grade, st_month } = form;
    dispatch(login({ t_type, diag_t_id, name, grade, st_month }));
  };

  const handleCheckClick = () => {
    setTest(!test);
  }

  useEffect(() => {
    dispatch(initializeForm("login"));
  }, [dispatch]);

  useEffect(() => {
    if (authError) {
      console.log("오류 발생");
      console.log(authError);
      return;
    } else if (auth) {
      if(test) history.push("/apitest");
      else history.push("/diagnosis/");
    }
  }, [auth, authError, dispatch, history, test]);

  return <TestForm form={form} onChange={onChange} onSubmit={onSubmit} isTest={test} handleCheckClick={handleCheckClick} />;
};

export default withRouter(TestContainer);
